import { BlockType, ComponentSettings, ContentSettings } from '@report-content';
import { ReportContentActions } from 'app/editor/report';

export abstract class AbstractComponentBuilder<T extends ComponentSettings> {
    constructor(
        protected contentSettings: ContentSettings,
        protected block: BlockType<T>,
        protected updateBlockSettings: (newSettings: ComponentSettings, options?: { shouldDirty?: boolean }) => void,
        protected actions: ReportContentActions,
    ) {}

    public abstract getComponent(editPanel?: any): any;
    public abstract getEditPanel(): any;
    public getComponentControls(): any {
        return null;
    }
}
